import concat from 'lodash/concat'
import get from 'lodash/get'
import memoize from 'lodash/memoize'
import * as scenes from '../scenes'
import * as overlayStyle from 'constants/overlayStyles'
import * as customFieldTypes from 'constants/customFieldTypes'
import * as sidebarSceneType from 'constants/sidebarSceneType'
import * as stylePresetType from 'constants/stylePresetType'

export function hd () {
  return (
    [ // eslint-disable-line indent
      {
        id: 'splash',
        location: { scene: scenes.SPLASH, showcaseNum: 0 },
        siderbarPreview: {
          type: sidebarSceneType.IMAGE,
          path: ['splash', 'logo'],
          isSmall: true,
        },
        fields: [
          {
            id: 'image',
            type: customFieldTypes.IMAGE,
            name: 'Logo',
            paths: [['splash', 'logo']],
            overlayStyle: overlayStyle.BlueField,
            overlayKey: 'ou_splash__logo',
            customStyle: '.ou_splash__logo {\n}',
            stylePresets: [
              { title: 'Image position:', className: `ou_splash__logo`, presetType: stylePresetType.POSITION },
              { title: 'Image size:', className: `ou_splash__logo`, presetType: stylePresetType.ZOOM },
              {
                title: 'Add background around image:',
                className: `ou_splash__logo`,
                presetType: stylePresetType.AROUND
              },
              { className: 'ou_splash__logo', presetType: stylePresetType.HIDDEN },
            ]
          },
          {
            id: 'text',
            type: customFieldTypes.TEXT,
            name: 'Subheading',
            paths: [['splash', 'title']],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: 'ou_splash__title',
            customStyle: '.ou_splash__title {\n}',
            stylePresets: [
              { title: 'Move Subheading:', className: 'ou_splash__title', presetType: stylePresetType.POSITION },
              {
                title: 'Text color:',
                className: 'ou_splash__title',
                presetType: stylePresetType.COLOR,
                options: ['black', 'white']
              },
              { title: 'Text effects:', className: `ou_splash__title`, presetType: stylePresetType.TEXT_EFFECT },
              { title: 'Text size:', className: `ou_splash__title--text`, presetType: stylePresetType.TEXT_SIZE },
              { className: 'ou_splash__title', presetType: stylePresetType.HIDDEN },
            ]
          }
        ]
      },
      {
        id: 'intro',
        location: { scene: scenes.INTRO, showcaseNum: 0 },
        siderbarPreview: {
          type: sidebarSceneType.IMAGE,
          path: ['intro', 'image'],
        },
        fields: [
          {
            id: 'image',
            type: customFieldTypes.IMAGE,
            name: 'Background Image',
            paths: [['intro', 'image']],
            overlayStyle: overlayStyle.GreenTransparent,
            overlayKey: 'ou_intro__doors',
            customStyle: '.ou_intro__doors {\n}\n.ou_static-logo {\n}',
            stylePresets: [
              { title: 'Zoom:', className: `ou_intro__doors`, presetType: stylePresetType.ZOOM },
              {
                title: 'Darken / Lighten:',
                className: `ou_intro__door`,
                presetType: stylePresetType.DARKEN_LIGHTEN
              },
              { title: 'Pan:', className: 'ou_intro__doors', presetType: stylePresetType.POSITION },
              { className: 'ou_intro__doors', presetType: stylePresetType.HIDDEN },
            ]
          },
          {
            id: 'logo',
            type: customFieldTypes.IMAGE,
            name: 'Logo',
            paths: [['intro', 'logo']],
            overlayStyle: overlayStyle.BlueField,
            overlayKey: 'ou_static-logo-intro',
            customStyle: '.ou_static-logo-intro {\n}',
            stylePresets: [
              { title: 'Image position:', className: `ou_static-logo-intro`, presetType: stylePresetType.POSITION },
              { title: 'Image size:', className: `ou_static-logo-intro`, presetType: stylePresetType.ZOOM },
              {
                title: 'Add background around image:',
                className: `ou_static-logo-intro`,
                presetType: stylePresetType.AROUND
              },
              { className: 'ou_static-logo-intro', presetType: stylePresetType.HIDDEN },
              // {
              //   title: 'Apply size/positioning to all logos',
              //   // !!! first class' value is applied to the rest
              //   classNames: [`ou_static-logo-intro`, `ou_static-logo-video`, `ou_static-logo-last-scene`],
              //   getSlideClassName: num => `ou_static-logo-showcase-p${num}`,
              //   presetType: stylePresetType.POSITION_ZOOM_ALL,
              // },
            ]
          },
          {
            id: 'bulletPoints',
            type: customFieldTypes.BULLET_POINTS,
            name: 'Bullet Points',
            paths: [
              ['intro', 'line1'],
              ['intro', 'line2'],
              ['intro', 'line3']
            ],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: 'ou_intro__content',
            customStyle: [1, 2, 3].map(i => `.ou_intro__content-line_${i} {\n}\n`),
            stylePresets: [
              {
                title: 'Text color:',
                className: 'ou_intro__content',
                presetType: stylePresetType.COLOR,
                options: ['black', 'white']
              },
              { title: 'Text effects:', className: `ou_intro__content`, presetType: stylePresetType.TEXT_EFFECT },
              { className: 'ou_intro__content', presetType: stylePresetType.HIDDEN },
            ]
          }
        ]
      },
      {
        id: 'videoScene',
        location: { scene: scenes.VIDEO, showcaseNum: 0 },
        siderbarPreview: {
          type: sidebarSceneType.IMAGE,
          path: ['door', 'video', 'thumbUrl'],
        },
        fields: [
          {
            id: 'video',
            type: customFieldTypes.VIDEO,
            name: 'Background Video',
            paths: [['door', 'video']],
            overlayStyle: overlayStyle.GreenTransparent,
            overlayKey: 'ou_video',
            customStyle: '.ou_video__video {\n}',
            stylePresets: [
              { title: 'Pan:', className: `ou_video__video`, presetType: stylePresetType.POSITION },
              { title: 'Zoom:', className: `ou_video__video`, presetType: stylePresetType.ZOOM },
              { className: 'ou_video__video', presetType: stylePresetType.HIDDEN },
            ]
          },
          {
            id: 'logo',
            type: customFieldTypes.IMAGE,
            name: 'Logo',
            paths: [['door', 'logo']],
            overlayStyle: overlayStyle.BlueField,
            overlayKey: 'ou_static-logo-video',
            customStyle: '.ou_static-logo-video {\n}',
            stylePresets: [
              { title: 'Image position:', className: `ou_static-logo-video`, presetType: stylePresetType.POSITION },
              { title: 'Image size:', className: `ou_static-logo-video`, presetType: stylePresetType.ZOOM },
              {
                title: 'Add background around image:',
                className: `ou_static-logo-video`,
                presetType: stylePresetType.AROUND
              },
              { className: 'ou_static-logo-video', presetType: stylePresetType.HIDDEN },
              // {
              //   title: 'Apply size/positioning to all logos',
              //   // !!! first class' value is applied to the rest
              //   classNames: [`ou_static-logo-video`, `ou_static-logo-intro`, `ou_static-logo-last-scene`],
              //   getSlideClassName: num => `ou_static-logo-showcase-p${num}`,
              //   presetType: stylePresetType.POSITION_ZOOM_ALL,
              // },
            ]
          },
          {
            id: 'text',
            type: customFieldTypes.ACTION_BUTTON_W_DESIGN,
            name: 'Button Text',
            paths: [['door', 'buttonCaption']],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: 'ou_video__button',
            customStyle: '.ou_video__button {\n}',
            stylePresets: [
              { title: 'Move The Button:', className: `ou_video__button`, presetType: stylePresetType.POSITION },
              {
                title: 'Text color:',
                className: 'ou_video__button',
                presetType: stylePresetType.COLOR,
                options: ['black', 'white']
              },
              { title: 'Text effects:', className: `ou_video__button`, presetType: stylePresetType.TEXT_EFFECT },
            ]
          }
        ]
      }
    ] // eslint-disable-line indent
  )
}

export function tl (num) {
  return (
    [ // eslint-disable-line indent
      {
        id: 'addSceneButton',
        location: { scene: scenes.SHOWCASE, showcaseNum: num },
        siderbarPreview: {
          type: sidebarSceneType.ADD_SCENE_BUTTON,
          text: 'Add Product Scene'
        },
        fields: []
      },
      {
        id: 'lastScene',
        location: { scene: scenes.SHOWCASE, showcaseNum: num, shareButtonsVisible: 0 },
        siderbarPreview: {
          type: sidebarSceneType.IMAGE,
          path: ['lastScene', 'image'],
        },
        fields: [
          {
            id: 'image',
            type: customFieldTypes.IMAGE,
            name: 'Background Image',
            paths: [['lastScene', 'image']],
            overlayStyle: overlayStyle.GreenTransparent,
            overlayKey: `ou_last-scene_image`,
            customStyle: '.ou_last-scene_image {\n}\n.ou_cart {\n}',
            stylePresets: [
              { title: 'Zoom:', className: `ou_last-scene_image`, presetType: stylePresetType.ZOOM },
              {
                title: 'Darken / Lighten:',
                className: `ou_last-scene_image`,
                presetType: stylePresetType.DARKEN_LIGHTEN
              },
              { title: 'Pan:', className: 'ou_last-scene_image', presetType: stylePresetType.POSITION },
              { className: 'ou_last-scene_image', presetType: stylePresetType.HIDDEN },
            ]
          },
          {
            id: 'logo',
            type: customFieldTypes.IMAGE,
            name: 'Logo',
            paths: [['lastScene', 'logo']],
            overlayStyle: overlayStyle.BlueField,
            overlayKey: `ou_static-logo-last-scene`,
            customStyle: `.ou_static-logo-last-scene {\n}`,
            stylePresets: [
              {
                title: 'Image position:',
                className: `ou_static-logo-last-scene`,
                presetType: stylePresetType.POSITION
              },
              { title: 'Image size:', className: `ou_static-logo-last-scene`, presetType: stylePresetType.ZOOM },
              {
                title: 'Add background around image:',
                className: `ou_static-logo-last-scene`,
                presetType: stylePresetType.AROUND
              },
              { className: 'ou_static-logo-last-scene', presetType: stylePresetType.HIDDEN },
            ]
          },
          {
            id: 'title',
            type: customFieldTypes.TEXT,
            name: 'title',
            paths: [['lastScene', 'title']],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: `ou_last-scene_title`,
            customStyle: '.ou_showcase__title {\n}',
            stylePresets: [
              {
                title: 'Text color:',
                className: 'ou_showcase__title',
                presetType: stylePresetType.COLOR,
                options: ['black', 'white']
              },
              { title: 'Text effects:', className: `ou_showcase__title`, presetType: stylePresetType.TEXT_EFFECT },
              { title: 'Text size:', className: 'ou_showcase__title--text', presetType: stylePresetType.TEXT_SIZE },
              { className: 'ou_showcase__title', presetType: stylePresetType.HIDDEN },
            ]
          },
          {
            id: 'author',
            type: customFieldTypes.TEXT,
            name: 'Author',
            paths: [['lastScene', 'author']],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: `ou_last-scene_author`,
            customStyle: '.ou_showcase__author {\n}',
            stylePresets: [
              {
                title: 'Text color:',
                className: 'ou_showcase__author',
                presetType: stylePresetType.COLOR,
                options: ['black', 'white']
              },
              { title: 'Text effects:', className: `ou_showcase__author`, presetType: stylePresetType.TEXT_EFFECT },
              { title: 'Text size:', className: 'ou_showcase__author--text', presetType: stylePresetType.TEXT_SIZE },
              { className: 'ou_showcase__author', presetType: stylePresetType.HIDDEN },
            ]
          },
          {
            id: 'subtitle',
            type: customFieldTypes.TEXT,
            name: 'Subtitle',
            paths: [['lastScene', 'subtitle']],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: `ou_last-scene_subtitle`,
            customStyle: '.ou_showcase__subtitle {\n}',
            stylePresets: [
              {
                title: 'Text color:',
                className: 'ou_showcase__subtitle',
                presetType: stylePresetType.COLOR,
                options: ['black', 'white']
              },
              { title: 'Text effects:', className: `ou_showcase__subtitle`, presetType: stylePresetType.TEXT_EFFECT },
              { title: 'Text size:', className: 'ou_showcase__subtitle--text', presetType: stylePresetType.TEXT_SIZE },
              { className: 'ou_showcase__subtitle', presetType: stylePresetType.HIDDEN },
            ]
          },
          {
            id: 'shareButton',
            type: customFieldTypes.SHARE_BUTTON,
            name: 'Edit share button',
            paths: [[ 'lastScene', 'shareButton' ]],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: 'ou_share__main-button',
            stylePresets: [
              {
                className: 'ou_share__main-button', presetType: stylePresetType.HIDDEN
              }
            ]
          }
        ]
      },
      {
        id: 'lastSceneShare',
        location: { scene: scenes.SHOWCASE, showcaseNum: num, shareButtonsVisible: 1 },
        siderbarPreview: { type: sidebarSceneType.HIDDEN },
        fields: [
          {
            id: 'shareTitle',
            type: customFieldTypes.TEXT,
            name: 'Edit share title',
            paths: [[ 'lastScene', 'shareTitle' ]],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: 'ou_share__title',
            stylePresets: [
              {
                title: 'Text color:',
                className: 'ou_share__title',
                presetType: stylePresetType.COLOR,
                options: ['black', 'white']
              },
              { title: 'Text effects:', className: `ou_share__title`, presetType: stylePresetType.TEXT_EFFECT },
              {
                className: 'ou_share__title', presetType: stylePresetType.HIDDEN
              }
            ]
          },
          {
            id: 'shareSubtitle',
            type: customFieldTypes.TEXT,
            name: 'Edit share subtitle',
            paths: [[ 'lastScene', 'shareSubtitle' ]],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: 'ou_share__subtitle',
            stylePresets: [
              {
                title: 'Text color:',
                className: 'ou_share__subtitle',
                presetType: stylePresetType.COLOR,
                options: ['black', 'white']
              },
              { title: 'Text effects:', className: `ou_share__subtitle`, presetType: stylePresetType.TEXT_EFFECT },
              {
                className: 'ou_share__subtitle', presetType: stylePresetType.HIDDEN
              }
            ]
          },
          {
            id: 'fb',
            type: customFieldTypes.EDIT_SOCIAL_URL,
            name: 'Edit Facebook',
            paths: [[ 'lastScene', 'social', 'facebook' ]],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: 'ou_share__button--facebook',
            stylePresets: [
              {
                className: 'ou_share__button--facebook',
                presetType: stylePresetType.HIDDEN
              }
            ]
          },
          {
            id: 'twitter',
            type: customFieldTypes.EDIT_SOCIAL_URL,
            name: 'Edit Twitter',
            paths: [[ 'lastScene', 'social', 'twitter' ]],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: 'ou_share__button--twitter',
            stylePresets: [
              {
                className: 'ou_share__button--twitter',
                presetType: stylePresetType.HIDDEN
              }
            ]
          },
          {
            id: 'email',
            type: customFieldTypes.EDIT_SOCIAL_URL,
            name: 'Edit Email',
            paths: [[ 'lastScene', 'social', 'email' ]],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: 'ou_share__button--email',
            stylePresets: [
              {
                className: 'ou_share__button--email',
                presetType: stylePresetType.HIDDEN
              }
            ]
          },
          {
            id: 'phone',
            type: customFieldTypes.EDIT_SOCIAL_URL,
            name: 'Edit Phone',
            paths: [[ 'lastScene', 'social', 'phone' ]],
            overlayStyle: overlayStyle.GreenField,
            overlayKey: 'ou_share__button--sms',
            stylePresets: [
              {
                className: 'ou_share__button--sms',
                presetType: stylePresetType.HIDDEN
              }
            ]
          }
        ]
      }
    ] // eslint-disable-line indent
  )
}

function createSlide (num, canDelete) {
  return [
    {
      id: `showcase${num}`,
      location: { scene: scenes.SHOWCASE, showcaseNum: num, shareButtonsVisible: 0 },
      canDelete: canDelete,
      siderbarPreview: {
        type: sidebarSceneType.IMAGE,
        path: ['showcases', num, 'image'],
        products: [
          { path: ['showcases', num, 'products', 0, 'title'], id: `showcase${num}ProductInfo1` },
          { path: ['showcases', num, 'products', 1, 'title'], id: `showcase${num}ProductInfo2` },
        ]
      },
      fields: [
        {
          id: 'image',
          type: customFieldTypes.IMAGE,
          name: 'Background Image',
          num: num,
          slideIdPath: ['showcases', num, 'slideId'],
          paths: [['showcases', num, 'image']],
          overlayStyle: overlayStyle.GreenTransparent,
          overlayKey: `ou_showcase__image${num}`,
          customStyle: `.ou_showcase_${num} {\n}\n.ou_showcase_${num}_image {\n}`,
          stylePresets: [
            {
              title: 'Zoom:',
              className: slideId => `ou_showcase_${slideId}_image_p`,
              presetType: stylePresetType.ZOOM
            },
            {
              title: 'Darken / Lighten:',
              className: slideId => `ou_showcase_${slideId}_image_p`,
              presetType: stylePresetType.DARKEN_LIGHTEN
            },
            {
              title: 'Pan:',
              className: slideId => `ou_showcase_${slideId}_image_p`,
              presetType: stylePresetType.POSITION
            },
            {
              className: slideId => `ou_showcase_${slideId}_image_p`,
              presetType: stylePresetType.HIDDEN
            }
          ]
        },
        {
          id: 'logo',
          type: customFieldTypes.IMAGE,
          name: 'Logo',
          num: num,
          slideIdPath: ['showcases', num, 'slideId'],
          paths: [['showcases', num, 'logo']],
          overlayStyle: overlayStyle.BlueField,
          overlayKey: `ou_static-logo-showcase-${num}`,
          customStyle: `.ou_static-logo-showcase-${num} {\n}`,
          stylePresets: [
            {
              title: 'Image position:',
              className: slideId => `ou_static-logo-showcase-p${slideId}`,
              presetType: stylePresetType.POSITION
            },
            {
              title: 'Image size:',
              className: slideId => `ou_static-logo-showcase-p${slideId}`,
              presetType: stylePresetType.ZOOM
            },
            {
              title: 'Add background around image:',
              className: slideId => `ou_static-logo-showcase-p${slideId}`,
              presetType: stylePresetType.AROUND
            },
            {
              className: slideId => `ou_static-logo-showcase-p${slideId}`,
              presetType: stylePresetType.HIDDEN
            },
            {
              title: 'Apply size/positioning to all logos',
              // !!! first class' value is applied to the rest
              classNames: [
                slideId => `ou_static-logo-showcase-p${slideId}`,
                `ou_static-logo-last-scene`,
                `ou_static-logo-video`,
                `ou_static-logo-intro`
              ],
              getSlideClassName: (num, cf) => {
                const slideId = get(cf, ['showcases', num, 'slideId'], num)
                return `ou_static-logo-showcase-p${slideId}`
              },
              presetType: stylePresetType.POSITION_ZOOM_ALL,
            },
          ]
        },
        {
          id: 'productLink1',
          type: customFieldTypes.PRODUCT,
          name: 'Product 1',
          num: num,
          slideIdPath: ['showcases', num, 'slideId'],
          paths: [['showcases', num, 'products', 0]],
          overlayStyle: overlayStyle.GreenField,
          overlayKey: `ou_product_link_${num * 2 + 1}`,
          customStyle: `.ou_showcase_link_${num * 2 + 1} {\n}`,
          stylePresets: [
            {
              title: 'Move link:',
              className: slideId => `ou_showcase_link_p${slideId}_0`,
              presetType: stylePresetType.POSITION
            },
            {
              title: 'Text color:',
              className: slideId => `ou_showcase_link_p${slideId}_0`,
              presetType: stylePresetType.COLOR,
              options: ['black', 'white']
            },
            {
              title: 'Text effects:',
              className: slideId => `ou_showcase_link_p${slideId}_0`,
              presetType: stylePresetType.TEXT_EFFECT
            },
            {
              className: slideId => `ou_showcase_link_p${slideId}_0`,
              presetType: stylePresetType.HIDDEN
            }
          ]
        },
        {
          id: 'productLink2',
          type: customFieldTypes.PRODUCT,
          name: 'Product 2',
          num: num,
          slideIdPath: ['showcases', num, 'slideId'],
          paths: [['showcases', num, 'products', 1]],
          overlayStyle: overlayStyle.GreenField,
          overlayKey: `ou_product_link_${num * 2 + 2}`,
          customStyle: `.ou_showcase_link_${num * 2 + 2} {\n}`,
          stylePresets: [
            {
              title: 'Move link:',
              className: slideId => `ou_showcase_link_p${slideId}_1`,
              presetType: stylePresetType.POSITION
            },
            {
              title: 'Text color:',
              className: slideId => `ou_showcase_link_p${slideId}_1`,
              presetType: stylePresetType.COLOR,
              options: ['black', 'white']
            },
            {
              title: 'Text effects:',
              className: slideId => `ou_showcase_link_p${slideId}_1`,
              presetType: stylePresetType.TEXT_EFFECT
            },
            {
              className: slideId => `ou_showcase_link_p${slideId}_1`,
              presetType: stylePresetType.HIDDEN
            }
          ]
        }
      ]
    },
    {
      id: `showcase${num}ProductInfo1`,
      location: { scene: scenes.PRODUCT_INFO, showcaseNum: num, productShown: num * 2 + 1, shareButtonsVisible: 0 },
      siderbarPreview: {
        type: sidebarSceneType.HIDDEN,
      },
      fields: [
        {
          id: `ou_product_card_button_${num * 2 + 1}`,
          type: customFieldTypes.ACTION_BUTTON,
          name: 'Edit text',
          paths: [['showcases', num, 'products', 0, 'buttonText']],
          overlayStyle: overlayStyle.GreenField,
          overlayKey: `ou_product_card_button_${num * 2 + 1}`
        }
      ]
    },
    {
      id: `showcase${num}ProductDetails1`,
      location: { scene: scenes.PRODUCT_DETAILS, showcaseNum: num, productShown: num * 2 + 1, shareButtonsVisible: 0 },
      siderbarPreview: {
        type: sidebarSceneType.HIDDEN
      },
      fields: [{
        id: 'product_variants',
        type: customFieldTypes.SHOPIFY_VARIANTS,
        name: 'Color variants',
        paths: [['showcases', num, 'products', 0]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: `ou_product_variants_${num * 2 + 1}`
      }]
    },
    {
      id: `showcase${num}ProductInfo2`,
      location: { scene: scenes.PRODUCT_INFO, showcaseNum: num, productShown: num * 2 + 2, shareButtonsVisible: 0 },
      siderbarPreview: {
        type: sidebarSceneType.HIDDEN,
      },
      fields: [
        {
          id: `ou_product_card_button_${num * 2 + 2}`,
          type: customFieldTypes.ACTION_BUTTON,
          name: 'Edit text',
          paths: [['showcases', num, 'products', 1, 'buttonText']],
          overlayStyle: overlayStyle.GreenField,
          overlayKey: `ou_product_card_button_${num * 2 + 2}`
        }
      ]
    },
    {
      id: `showcase${num}ProductDetails2`,
      location: { scene: scenes.PRODUCT_DETAILS, showcaseNum: num, productShown: num * 2 + 2, shareButtonsVisible: 0 },
      siderbarPreview: {
        type: sidebarSceneType.HIDDEN
      },
      fields: [{
        id: 'product_variants',
        type: customFieldTypes.SHOPIFY_VARIANTS,
        name: 'Color variants',
        paths: [['showcases', num, 'products', 1]],
        overlayStyle: overlayStyle.GreenField,
        overlayKey: `ou_product_variants_${num * 2 + 2}`
      }]
    }
  ]
}

export function createCustomFieldsSimple (slidesCnt) {
  let res = hd()
  for (let i = 0; i < slidesCnt; i++) {
    res = concat(res, createSlide(i, i + 1 === slidesCnt))
  }
  res = concat(res, tl(slidesCnt))
  return res
}

export const createCustomFields = memoize(createCustomFieldsSimple)



// WEBPACK FOOTER //
// ./src/templates/outSide/template/customFields.js